
import {createSlice} from "@reduxjs/toolkit";

export const batchEventSlice = createSlice({
    name: 'batchEventSlc',
    initialState: {value: {id: 0, ordinalNumber: null, started: null, phase: null, step: null, subjectRecordId: null, subjectTable: null,
            subjectChangeType: null, objectRecordId: null, objectTable: null, action: null, result: null,
            createdOn: null, cratedBy: null, lastModifiedOn:null,lastModifiedBy:null,
            drawerState: false}},
    reducers:
{
    changeBatchEvent: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeBatchEvent } = batchEventSlice.actions;

export default  batchEventSlice.reducer ;
